<template>   
  <div>
    <v-card-text class="pa-3" style="min-height: 400px" v-if="fm">
      <v-container grid-list-lg fluid class="pa-0 ma-0">
        <v-layout row wrap v-if="fm.status">                      
          <template v-if="fm.status < 3">
            <template v-if="fm.jalur_id == 2">
              <v-alert :value="true" color="info" icon="info" style="font-size:15px" outline>            
                Terima Kasih telah mengisi form administrasi.
                Ananda sedang mengikuti jalur prestasi.<br/><br/>
                <strong>Berkas Ananda akan diverifikasi oleh admin terlebih dahulu. <br/>
                Jika dalam 1 x 24 jam status ananda belum berubah silahkan hubungi admin dengan mengklik chat wa pada pojok kanan bawah.
                </strong><br/><br/>
                Terima kasih.
                
              </v-alert>  
            </template>
            <template v-else>
              <v-flex xs12 v-if="fm.payment_image_url">
                <v-alert :value="true" color="blue" icon="info" outline>            
                  Terima Kasih telah mengupload bukti pembayaran. Status ananda saat ini adalah <strong>menunggu verivikasi Pihak Keuangan (1 x 24 jam).</strong>
                  Jika verifikasi tidak muncul diluar waktu tersebut silahkan hubungi admin dengan mengklik icon WhatsApp pada pojok kanan bawah.                  
                </v-alert>          
                <p class="mt-3">
                  <strong>Bukti pembayaran :</strong> <br/>             
                  <img style="max-width:400px; width:100%" class="mb-8" :src="$config.url+'cdn/img/payment/'+fm.payment_image_url" />              
                </p>                              
                <v-btn @click="container_upload = true">Upload Ulang Bukti Pembayaran</v-btn>                
              </v-flex>
              <v-flex xs12 v-else>            
                <v-alert :value="true" color="warning" icon="info" outline>            
                  Terima Kasih telah mengisi form administrasi. Status Ananda saat ini adalah <strong>belum membayar</strong>. 
                </v-alert>                                       
              </v-flex>      
              <v-flex xs12 v-if="container_upload">
                <p class="subheading mt-4 mb-0 font-weight-regular">
                  Silahkan <!--pilih salah satu opsi dibawah--> transfer untuk melakukan pembayaran. Nominalnya adalah 
                  <strong class="title">Rp{{getBiaya() | currency}},-</strong>
                </p>       
              </v-flex>
              <v-flex lg6 xs12 v-if="container_upload">                 
                <div style="border:1px solid #aaa" class="pa-3">
                  <h3 class="mb-3">Transfer Rekening</h3>
                  <img :src="require('@/assets/img/bsi.jpg')" class="mr-3" style="height:144px" ></img>
                  <img :src="require('@/assets/img/atmbersama.jpg')" class="" style="height:144px" ></img>                
                  <ol class="mt-4">
                    <li>Transfer Ke Rekening BSI:<br/>
                      <h3>2223222307 an Yayasan Waqaf Ar-Risalah</h3> <!--Kode Bank <strong>009</strong>-->
                    </li>
                    <li>Masukkan nominal sesuai yang tertera di atas</li>
                    <li>Masukkan Nomor Referensi <strong>{{fm.reff_bill}}</strong></li>
                    <li>Upload Foto Bukti Transfer pada kolom berikut, dan status akan berubah maksimal 1x24 jam </li>
                    <!--<li>Upload Foto Bukti Transfer dan kirim via WhatsApp ke nomor <a target="_blank" :href="'https://api.whatsapp.com/send?phone='+$config.cpk.wa"><img :src="require('@/assets/img/waicon.png')" class="mx-2" style="height:25px" /> <strong>{{$config.cpk.label}}</strong> ({{$config.cpk.name}})</a></li>
                    <li>Simpan Bukti Transfer, status akan berubah maks 1x24 jam. </li>-->                  
                  </ol>
                </div>
              </v-flex>  
              <v-flex lg6 xs12 v-if="container_upload">
                <div style="border:1px solid #aaa; position:relative; min-height:350px" class="pa-0">
                  <h3 class="px-3" style="position:absolute; z-index:9; top:15px">Upload Bukti Transfer Disini</h3>
                  <div class="DashboardContainer"></div>                
                </div>
              </v-flex> 
              <v-flex xs12>
              <v-divider class="mt-4" />
                <p class="mt-4" v-if="fm.jalur_id != 3 && fm.jalur_id != 4">

                  <h3>Sembari menunggu konfirmasi pembayaran, lakukan persiapan berikut :</h3>
                  <ul v-if="fm.tingkat_id > 1">
                    <li class="my-2">Download file berikut : 
                      <v-btn round color="blue" :href="$config.url+'cdn/file/sknSD.pdf'" target="_blank" v-if="fm.tingkat_id == 2" dark small>Download Blangko Rapor</v-btn>
                      <v-btn round color="blue" :href="$config.url+'cdn/file/sknSMP.pdf'" target="_blank" v-if="fm.tingkat_id == 3" dark small>Download Blangko Rapor</v-btn>
                    </li>
                    <li class="my-2">
                      Isi blangko tersebut lalu tandatangani oleh Kepala Sekolah bersangkutan.
                    </li>
                    <li class="my-3">Setelah itu scan atau foto blangko yg telah ditandatangani tersebut menjadi format .pdf</li>
                    <li class="my-3">File ini akan diupload pada step ke-5</li>
                  </ul>
                  <ol v-if="fm.tingkat_id == 1">        
                    <li class="my-3">Scan akta kelahiran dalam format .pdf</li>
                    <li class="my-3">File ini akan diupload pada step ke-5</li>
                  </ol>  
                </p>
              </v-flex>
            </template>
          </template>                                        
          <v-flex xs12 v-else-if="fm.status >= 3">
            <v-alert :value="true" color="success" icon="check" outline v-if="fm.jalur_id == 2">            
              <span class="headline">
                Status : Ananda sedang mengikuti jalur prestasi, <strong>tidak perlu membayar</strong> uang pendaftaran.
              </span><br/>
              <span>Silahkan lanjut ke tahap selanjutnya</span>
            </v-alert>  
            <v-alert :value="true" color="success" icon="check" outline v-else>            
              <span class="headline">
                Status : terima kasih Ananda <strong>telah membayar</strong> uang pendaftaran.
              </span>
            </v-alert>  
          </v-flex>     
        </v-layout>  
      </v-container>
    </v-card-text>  
    <v-card-text v-else>
      loading... please wait.
    </v-card-text>
    <v-card-actions v-if="fm && fm.status >= 3">
      <v-spacer></v-spacer>
      <v-btn color="primary" class="pa-1" :loading="loading" @click="$emit('update:stepke', 4)">Continue</v-btn>
    </v-card-actions> 
  </div>
</template>
<script>
import Model from '@/models/dashboard';
import User  from '@/util/models/User';
const  model = new Model();

import 'uppy/dist/uppy.min.css';
import Interface   from '@/util/interface';
const  api = Interface.biz4;


export default {
  name:'step3',  
  props:{
    stepke:{
      type: Number,
      default: null,
    },
    loading : {
      type: Boolean,
      default: false,
    }
  },
  data:()=>({      
    stepkeLocal : null,
    user : User.attributes(),
    tingkats:[],
    fm:{},
    container_upload : true,
  }),
  components: { 
  },  
  watch:{
    stepke(newStep){this.stepkeLocal = newStep; this.init();},
    stepkeLocal(newStep){this.$emit('update:stepke', newStep)},
    container_upload(nVal){
      if(nVal){
        setTimeout(()=>{this.setUploads()}, 10);            
      }
    }
  },
  asyncComputed:{
    
  }, 
  mounted(){
    model.tingkats().then(data=>{
      this.tingkats = data;      
    });

    this.init();
  },
  methods:{
    init(){
      this.fm = {};
      model.viewAdministrasi({id:this.user.id}).then(data=>{
        if(data.payment_image_url){
          this.container_upload = false
        }
        if(!this.fm.id && this.container_upload){
          setTimeout(()=>{this.setUploads()}, 10);            
        }        
        this.fm = data;
        if(this.fm.payment_image_url){
          this.fm.payment_image_url += '?'+ new Date().getTime()
        }                                           
      });
    },

    getBiaya(){
      let biaya   = 250000;
      let tingkat = this.tingkats.find(x=>x.id===this.fm.tingkat_id)
      if(tingkat){
          biaya = tingkat.biaya
          if(this.fm.jalur_id == 3){
            if(this.fm.tingkat_id == 3){
              biaya = 100000;
            }            
            if(this.fm.tingkat_id == 2){
              biaya = 100000;
            }
            if(this.fm.tingkat_id == 1){
              biaya = 50000;
            }             
          }
      }      
      return biaya
    },    

    setUploads(){
      try{
        const Uppy = require('@uppy/core')
        const Dashboard = require('@uppy/dashboard')
        const XHRUpload = require('@uppy/xhr-upload')
        //const GoogleDrive = require('@uppy/google-drive')
        //const Dropbox = require('@uppy/dropbox')
        //const Instagram = require('@uppy/instagram')
        //const Webcam = require('@uppy/webcam')
        //const Tus = require('@uppy/tus')
        
        const rest = api.setter('ppdb/dashboard/upload-payment');
        const uppy = Uppy({
          debug: false,
          autoProceed: false,
          restrictions: {
            maxFileSize: 100000000,
            maxNumberOfFiles: 1,
            minNumberOfFiles: 1,
            allowedFileTypes: ['image/*']
            //allowedFileTypes: ['image/*', 'video/*']
          }
        })
        .use(Dashboard, {
          trigger: '.UppyModalOpenerBtn',
          inline: true,
          target: '.DashboardContainer',
          replaceTargetContent: true,
          showProgressDetails: true,
          note: 'Image only, 1 file, up to 100 MB',
          height: 350,
          width:'100%',
          metaFields: [
            { id: 'name', name: 'Name', placeholder: 'file name' },
            { id: 'caption', name: 'Caption', placeholder: 'describe what the file is about' }
          ],
          browserBackButtonClose: true
        })
        //.use(GoogleDrive, { target: Dashboard, serverUrl: 'https://companion.uppy.io' })
        //.use(Dropbox, { target: Dashboard, serverUrl: 'https://companion.uppy.io' })
        //.use(Instagram, { target: Dashboard, serverUrl: 'https://companion.uppy.io' })
        //.use(Webcam, { target: Dashboard })
        //.use(Tus, { endpoint: 'https://master.tus.io/files/' })
        .use(XHRUpload, {
          endpoint: rest.endpoint,
          headers: rest.headers,
          formData: true,
          fieldName: 'file',  
        })
        uppy.on('complete', (result) => {
          if(result.successful && result.successful.length > 0){
            this.init()
          }        
        });      
      }catch(e){}
    },
  }
};
</script>


